import { render, staticRenderFns } from "./NotiPos.vue?vue&type=template&id=7a9ab51a&"
import script from "./NotiPos.vue?vue&type=script&lang=js&"
export * from "./NotiPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports